import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Users } from '../../../model/users';
import { Observable } from 'rxjs';
import { StorageService } from '../../managers/storage.service';
import { Config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends Config {

  constructor(private httpClient: HttpClient, private storageService: StorageService) {
    super();
  }

  public loginUser(user: Users): Observable<any> {
    var url = "user_login";

    return this.httpClient.post(this.BASE_URL + url, user);
  }

  public storeUser(user: Users): Observable<any> {
    var url = "user_store";

    return this.httpClient.post(this.BASE_URL + url, user, this.storageService.getHeaders());
  }

  public updateUser(user: Users): Observable<any> {
    var url = "user_update";

    return this.httpClient.post(this.BASE_URL + url, user, this.storageService.getHeaders());
  }

  public getUsers(maxItemsPerPage: number, page: number, keyword: string): Observable<any> {
    var url = "users?maxItemsPerPage=" + maxItemsPerPage + "&page=" + page + "&keyword=" + keyword;

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

  public getUser(id: number): Observable<any> {
    var url = "user_show";

    return this.httpClient.post(this.BASE_URL + url, { "id": id }, this.storageService.getHeaders());
  }

  public getUserList(): Observable<any>{
    var url = "get_staff";

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }
  
  public saveAssignedUsers(selUser:any): Observable<any>{
    var url = "assign_staff";

    return this.httpClient.post(this.BASE_URL + url, selUser, this.storageService.getHeaders());
  }
  public getAssignedUsers(): Observable<any>{
    var url = "get_assigned_staff";

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

  

  public uploadPID(file: any): Observable<any> {
    var url = "user_upload_pid";
    return this.httpClient.post(this.BASE_URL + url, file,this.storageService.getHeaders());
  }

}
